import React from 'react';
import { DataFlowSidePanel, DescriptionSection } from './StyledPanelComponents';

const ModelInferenceContextPanel = ({
  id,
  name,
  detailsPanelClearAll,
  zoomToNode,
}: {
  id: string;
  name: string;
  detailsPanelClearAll: () => void;
  zoomToNode?: () => void;
}) => {
  return (
    <DataFlowSidePanel
      name={name}
      prehead="Model Inference"
      nodeId={id}
      detailsPanelClearAll={detailsPanelClearAll}
      zoomToNode={zoomToNode}
    >
      <DescriptionSection
        description={`Real-time consumer(s) of the '${name}' Feature Service. This is your production model.`}
      />
    </DataFlowSidePanel>
  );
};

export default ModelInferenceContextPanel;
